// ============================================================
// Der einzige Weg zum Backend. Dieselben Festlegungen wie in lilasprojekte
// (frontend/src/api/client.ts dort, ausführlich begründet):
//   relative Adresse unter /api, cache "no-store", credentials "same-origin",
//   X-LP: 1 auf jeder verändernden Anfrage (CSRF-Riegel des Hauses).
// ============================================================

const BASIS = "/api";
const VERAENDERND = new Set(["POST", "PUT", "PATCH", "DELETE"]);

export class ApiFehler extends Error {
  readonly status: number;
  constructor(status: number, detail: string) {
    super(detail);
    this.name = "ApiFehler";
    this.status = status;
  }
}

let beiAbmeldung: (() => void) | null = null;
export function setzeAbmeldeHandler(fn: () => void): void {
  beiAbmeldung = fn;
}

export async function api<T>(methode: string, pfad: string, rumpf?: unknown): Promise<T> {
  const kopf: Record<string, string> = {};
  if (VERAENDERND.has(methode)) kopf["X-LP"] = "1";
  let body: BodyInit | undefined;
  if (rumpf instanceof FormData) {
    body = rumpf;
  } else if (rumpf !== undefined) {
    kopf["Content-Type"] = "application/json";
    body = JSON.stringify(rumpf);
  }
  let antwort: Response;
  try {
    antwort = await fetch(BASIS + pfad, {
      method: methode, headers: kopf, body, cache: "no-store", credentials: "same-origin",
    });
  } catch {
    throw new ApiFehler(0, "Keine Verbindung zum Server. Netz prüfen und noch einmal versuchen.");
  }
  if (antwort.status === 401 && !pfad.startsWith("/auth/")) beiAbmeldung?.();
  const text = await antwort.text();
  let daten: unknown = null;
  try {
    daten = text ? JSON.parse(text) : null;
  } catch {
    daten = null;
  }
  if (!antwort.ok) {
    const detail =
      daten && typeof daten === "object" && "detail" in daten && typeof daten.detail === "string"
        ? daten.detail
        : `Der Server hat mit ${antwort.status} geantwortet.`;
    throw new ApiFehler(antwort.status, detail);
  }
  return daten as T;
}

export const lies = <T>(pfad: string) => api<T>("GET", pfad);
export const schick = <T>(pfad: string, rumpf?: unknown) => api<T>("POST", pfad, rumpf);
export const aender = <T>(pfad: string, rumpf: unknown) => api<T>("PATCH", pfad, rumpf);
export const weg = <T>(pfad: string) => api<T>("DELETE", pfad);
